import { useNotFoundFloraModel } from '@/components/shared/not-found-flora/not-found-flora.model'
import { NotFoundFloraView } from '@/components/shared/not-found-flora/not-found-flora.view'

export function NotFoundFloraViewModel() {
  const model = useNotFoundFloraModel()
  return <NotFoundFloraView {...model} />
}
